import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import groupPlaceholder1 from "assets/images/groups_placeholder1.png";
import { showErrorMessage, showSuccessMessage } from "common/AlertContainer";
import QuickInfo from "common/QuickInfo/QuickInfo";
import { memo, useState } from "react";
import LinesEllipsis from "react-lines-ellipsis";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Button,
  ButtonDropdown,
  Card,
  CardImg,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import Swal from "sweetalert2";
import { ConnectionServices } from "utils/ConnectionServices";
import { FAILTOSAVERECOED } from "utils/Constants";

const GroupItem = ({ group, activeTab, handleEditItem, reportClick, setGroupIdToAct, toggleAlert, isGetDataAvailable, getData }) => {
  const [dropdownOpen, seDropdownOpen] = useState(false);
  const toggle = () => {
    seDropdownOpen(!dropdownOpen);
  };
  const currentUser = useSelector((state) => state.auth.currentUser);

  const handleMembershipClick = (groupId) => {
    Swal.fire({
      title: `Are you sure, you want to leave this group?`,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        leaveTheGroup(groupId);
      }
    });
  };

  const leaveTheGroup = (groupId) => {
    ConnectionServices.leaveTheGroup(currentUser?.guid, groupId).then((response) => {
      if (response.status === 204) {
        showSuccessMessage("You have left the Group, successfully...");
        if (isGetDataAvailable)
          getData(0, []);
      } else {
        showErrorMessage(FAILTOSAVERECOED);
      }
    });
  };


  return (
    <Card className="nex-list-card-v2 bg-white">
      <div className="card-body">
        <div className="nex-stack nex-group-item-stack">
          <QuickInfo isTitleLink={true} titleLink={`/connections/groups/${group.id}`}
            avatar={<img
              width="100%"
              src={
                group.bannerId
                  ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${group.id}/${group.bannerId}`
                  : groupPlaceholder1
              }
              className="nex-avatar lg"
              alt="Card image cap" />
            }
            title={group.name}

          >
            <p className="nex-text">
              {group.members}
            </p>
            <LinesEllipsis
              className="card-text"
              text={group.description}
              maxLine="2"
              ellipsis="..."
              trimRight
              basedOn="letters"
            />
          </QuickInfo>

          <div className="action inline ml-auto my-auto">
            {isGetDataAvailable &&
              <Button
                color="primary"
                className="nex-btn-danger-outline round-lg"
                onClick={() => handleMembershipClick(group?.id)}
              >
                <span className="icon"><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="13"
                  fill="none"
                  viewBox="0 0 14 13"
                >
                  <path
                    stroke="#FF7F96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.2"
                    d="M9.5 5.958h2.956M4.33 8.125h4.333c1.197 0 2.167.97 2.167 2.167v1.083H2.164v-1.083c0-1.197.97-2.167 2.167-2.167zm4.333-4.333a2.167 2.167 0 11-4.333 0 2.167 2.167 0 014.333 0z"
                  ></path>
                </svg></span> Exit Group
              </Button>
            }

            {activeTab === "0" && (
              <div className="actions">
                <div className="btns">
                  <span className='btn'
                    onClick={() => handleEditItem(group)}
                  >
                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="19" cy="19" r="18.625" fill="white" stroke="#79E0FF" strokeWidth="0.75" />
                      <path d="M23.1939 11.1592L21.3778 12.9754L25.0101 16.6077L26.8263 14.7915L23.1939 11.1592ZM19.5616 14.7915L12.2969 22.0562V25.6886H15.9292L23.1939 18.4239L19.5616 14.7915Z" fill="#46ABC9" />
                    </svg>
                  </span>
                </div>
              </div>
            )}
            {activeTab === "1" && (
              <div className="">
                <Button
                  className=" nex-btn-primary-outline nex-gi-group-unfollow-link"
                  onClick={
                    () => {
                      setGroupIdToAct(group.id)
                      toggleAlert();
                    }}>
                  Unfollow
                </Button>

              </div>
            )}
          </div>
          <div className="col-auto col-img d-none">
            <CardImg
              className="card-img card-img-md nexogic-grid-col-image"
              width="100%"
              src={
                group.bannerId
                  ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${group.id}/${group.bannerId}`
                  : groupPlaceholder1
              }
              alt="Card image cap"
            />

          </div>
          <div className="col col-content-right-btn position-relative d-none">
            <div className="nexogic-content-details">
              <h3 className="card-title">
                {activeTab === "1" && (
                  <div className="">
                    <ButtonDropdown
                      className="nexogic-float-drops-btn nex-gi-float-drops-btn"
                      isOpen={dropdownOpen}
                      toggle={toggle}
                    >
                      <DropdownToggle
                        color="link"
                        className="min-w-0 group-follow-item nex-gi-group-follow-item-link"
                      >
                        <FontAwesomeIcon
                          color="#2D4552"
                          className="font-weight-500"
                          size="sm"
                          icon={faEllipsisH}
                        />
                      </DropdownToggle>
                      <DropdownMenu className="filter-menu" right>
                        <DropdownItem
                          className="nex-gi-group-unfollow-link"
                          onClick={
                            () => {
                              setGroupIdToAct(group.id)
                              toggleAlert();
                            }}>
                          Unfollow
                        </DropdownItem>
                      </DropdownMenu>
                    </ButtonDropdown>
                  </div>
                )}
                <Link className="group-link nex-gi-group-group-name" to={`/connections/groups/${group.id}`}>
                  {group.name}
                </Link>
              </h3>
              <div className="card-text">
                {group.members}
              </div>
              <LinesEllipsis
                className="card-text"
                text={group.description}
                maxLine="2"
                ellipsis="..."
                trimRight
                basedOn="letters"
              />


            </div>
            <div className="nexogic-action-part">
              {activeTab === "0" && (
                <div className="actions">
                  <Button
                    color="primary"
                    className="nex-btn-primary nex-gi-group-edit-btn"
                    onClick={() => handleEditItem(group)}
                  >
                    Edit
                  </Button>
                </div>
              )}
            </div>

          </div>
        </div>








      </div>
    </Card>
  );
};

GroupItem.defaultProps = {
  handleEditItem: () => { },
  reportClick: () => { },
};

export default memo(GroupItem);
